import { useEffect, useState } from 'react'
import Project from '@/types/Project'
import Interview from '@/types/Interview'
import AttachmentsList from '@/components/shared/AttachmentsList'
import './PortalProjectsInterviews.scss'
import TitledRecordsSelect, { TitledRecordsSelectOptionValueType } from '@/components/TitledRecordsSelect'
import ProjectInterviewsSelect from '@/components/ProjectInterviewsSelect'

interface Props {
  projects: Required<Project>[],
  interviews?: TitledRecordsSelectOptionValueType<Interview>,
  project?: Required<Project>,
}

export default function PortalProjectsInterviews({
  projects,
  project,
  interviews,
}: Props) {
  const [selectedProject, setSelectedProject] = useState<Required<Project>>(projects[0])
  const [selectedInterviews, setSelectedInterviews] = useState<Interview | Interview []>(projects[0].interviews)
  const selectedProjectAttachments = selectedProject?.attachments ?? []

  useEffect(() => {
    if (!project || !interviews) return

    setSelectedProject(project)
    setSelectedInterviews(interviews)
  }, [project, interviews])

  return (
    <div className="PortalProjectsInterviews position-relative d-flex flex-column gap-3">
      <TitledRecordsSelect<Required<Project>>
        value={selectedProject}
        options={projects}
        onChange={p => {
          const project = p as Required<Project>
          setSelectedProject(project)
          setSelectedInterviews(project.interviews)
        }}
      />
      <ProjectInterviewsSelect
        value={selectedInterviews}
        options={selectedProject.interviews}
      />
      {selectedProjectAttachments.length > 0 && (
        <div className="PortalProjectsInterviews__AttachmentsSidebar">
          <AttachmentsList title="Attachments" attachments={selectedProjectAttachments} />
        </div>
      )}
    </div>
  )
}
